import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import EntryTableHead from './EntryTableHead';
import EntryTableToolBar from './EntryTableToolBar';
import EntryItem from './EntryItem';
import getVisibleEntries from '../../selectors/entries';
import LoadingPage from '../loading/LoadingPage';
import { downloadCSV, startSetEntry, startFetchVendors, startFetchDivisions, startFetchExpenseAccounts } from '../../actions';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});

export class EntryList extends Component {

  state = {
    order: 'asc',
    orderBy: 'created_at',
    selected: [],
    page: 0,
    rowsPerPage: 50,
    // entries: this.props.entries,
    // vendors: this.props.vendors,
  }

  componentDidMount() {
    if (this.props.vendors.length === 0) {
      this.props.startSetEntry({});
      this.props.startFetchVendors();
      this.props.startFetchExpenseAccounts();
      this.props.startFetchDivisions();
    }
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    const entries =
      order === 'desc'
        ? this.props.entries.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
        : this.props.entries.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
    this.setState({ entries, order, orderBy });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState({ selected: this.props.entries.map(entry => entry.id) });
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleDownload = () => {
    this.props.downloadCSV(this.state.selected);
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, errMessage, vendors, loading } = this.props;
    const { order, orderBy, selected, rowsPerPage, page } = this.state;
    if (this.props.allEntries.length === 0) {
      return <LoadingPage />
    }
    // const emptyRows = rowsPerPage - Math.min(rowsPerPage, this.state.entries.length - page * rowsPerPage);
    return (
      <Paper className={classes.root}>
        <EntryTableToolBar numSelected={selected.length} downloadCSV={this.handleDownload}/>
        <div className={classes.tableWrapper}>
         <Table className={classes.table}>
           <EntryTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={this.handleSelectAllClick}
            onRequestSort={this.handleRequestSort}
            rowCount={this.props.entries.length}
           />
           <TableBody>
             {
               this.props.entries.length === 0 ? (
                 <TableRow>
                   <TableCell>
                     {/* <Typography variant="subheading">{errMessage === '' ? 'No entries to display' : errMessage }</Typography> */}
                      <Typography variant="subheading">{loading && errMessage !== '' ? <CircularProgress className={classes.progress} size={25} /> : 'No entries to display' }</Typography>
                   </TableCell>
                 </TableRow>
               ) : (
                this.props.entries.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage).map((entry) => {
                    const isSelected = this.isSelected(entry.id);

                   return <EntryItem key={entry.id} vendors={vendors} history={this.props.history} isSelected={isSelected} onClick={this.handleClick} {...entry} />;
                 })
               )
             }
             {/* {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={8} />
                  </TableRow>
                )} */}
           </TableBody>
           <TableFooter>
             <TableRow>
               <TablePagination
                 rowsPerPageOptions={[30, 40, 50, this.props.entries.length]}
                 colSpan={8}
                 count={this.props.entries.length}
                 rowsPerPage={rowsPerPage}
                 page={page}
                 backIconButtonProps={{
                   'aria-label': 'Previous Page',
                 }}
                 nextIconButtonProps={{
                   'aria-label': 'Next Page',
                 }}
                 onChangePage={this.handleChangePage}
                 onChangeRowsPerPage={this.handleChangeRowsPerPage}
               />
             </TableRow>
           </TableFooter>
        </Table>
      </div>
    </Paper>
    );
  }
}

const mapStateToProps = ({ entries, filters, errors, vendors, appLoading }) => {
  const { errMessage } = errors;
  return {
    entries: getVisibleEntries(entries, filters),
    vendors,
    allEntries: entries,
    errMessage,
    loading: appLoading.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    downloadCSV: (entries) => dispatch(downloadCSV(entries)),
    startSetEntry: () => dispatch(startSetEntry({})),
    startFetchVendors: () => dispatch(startFetchVendors()),
    startFetchDivisions: () => dispatch(startFetchDivisions()),
    startFetchExpenseAccounts: () => dispatch(startFetchExpenseAccounts())
  };
};

EntryList.defaultProps = {
  entries: [],
  errMessage: '',
};

EntryList.propTypes = {
  entries: PropTypes.array.isRequired
};

export default compose(
  withStyles(styles, {
    name: 'EntryList',
  }), connect(mapStateToProps, mapDispatchToProps))(EntryList);



// WEBPACK FOOTER //
// ./src/components/entries/EntryList.js